import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* undoDepositFromSavings(action: ActionInterface): any {
  try {
    const res = yield call(Http.delete, `charges/${action.payload?.chargeId}/undo-deposit`, {} );

    yield put({ type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS })
    yield put({ type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchUndoDepositToSavings() {
  yield takeEvery(Constants.GLOBAL_UNDO_DEPOSIT_FROM_SAVINGS_ACCOUNT_START, undoDepositFromSavings);
}
